// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__5c9Pj","title":"style_title__CIer2","time":"style_time__30y_Q","content":"style_content__3-bT3","tabs":"style_tabs__YN_I6"};